export default __webpack_public_path__ + "static/media/classify-carl.d4d9a208.jpg";